module.exports = __webpack_public_path__ + "images/share9c070023ee855e40ecb917174845a5ce.svg";